import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCuentaValidator]',
})
export class CuentaValidatorDirective {
  private regex: RegExp = new RegExp(/^\d{0,20}$/);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value.replace(/\D/g, '');
    let next: string = current.concat(event.key);

    if (!this.regex.test(next) || next.length > 20) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let inputElement = event.target as HTMLInputElement;
    let value = inputElement.value.replace(/\D/g, ''); // Remove all non-digit characters

    if (value.length > 20) {
      value = value.substring(0, 20); // Trim to 20 characters
    }

    inputElement.value = value;
  }
}
